var map = {
	"./allergies@2x.png": 837,
	"./ancestry_main@2x.png": 838,
	"./appointments@2x.png": 839,
	"./conditions@2x.png": 840,
	"./health_main@2x.png": 841,
	"./prescriptions@2x.png": 842,
	"./tests@2x.png": 843,
	"./vaccinations@2x.png": 844
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 836;